import Footer from '../footer';
import Header from '../header';

const ResultsLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

export default ResultsLayout;
